<div class="container-fluid wallet-container bg-white shadow-sm rounded p-3 p-md-4 d-flex flex-column vh-100">
    <div class="wallet-header d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mb-4">
        <div>
            <div class="d-flex justify-content-start align-items-center" (click)="dialogRef.close()">
                <mat-icon fontIcon="arrow_back"></mat-icon>
                <span>Back</span>
            </div>
            <h2 class="mt-4 main-text">Add Wallet</h2>
            <p class="text-muted small">Select the wallet you wish to add and start spending using the selected currency</p>
        </div>
    </div>

    <div class="wallet-list flex-grow-1 overflow-auto mt-3">
        <div
            *ngFor="let wallet of filterWallets"
            class="wallet-item d-flex align-items-center justify-content-between m-3 pb-2"
            [ngClass]="{ selected: wallet.selected }"
            (click)="handleSelectWalletItem(wallet)"
        >
            <div class="wallet-info d-flex align-items-center justify-content-start">
                <mat-icon *ngIf="wallet.selected" class="text-success me-2">check</mat-icon>
                <img [src]="wallet.flag" [alt]="wallet.currencyName" class="flag-icon me-3" />
                <div>
                    <p class="mb-0 font-weight-bold">{{ wallet.currencyName }}</p>
                    <small class="text-muted">{{ wallet.currencyCode }}</small>
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-between align-items-center mt-4">
        <button
            [class.button-spinner]="isLoading"
            (click)="handleAddWallet()"
            class="main-btn d-flex justify-content-between align-items-center position-relative"
            [class.btn-primary-disabled]="!enableAddButton"
            [disabled]="!enableAddButton"
        >
            <span *ngIf="!isLoading">Add wallet</span>
        </button>
    </div>
</div>
